import type { Branding } from '@tsTypes/api/Branding';
import { pushClickMenuGTMEvent } from '@utils/gtm';

type UpperLinksProps = {
  links: NonNullable<Branding['footerLink']>['up'];
};

const UpperLinks = ({ links }: UpperLinksProps) => {
  const hasAnyLinkVisible = links.some(({ name }) => !!name);

  if (!hasAnyLinkVisible) {
    return null;
  }

  return (
    <ul
      tw="text-center pt-5 md:pt-0 xl:flex xl:items-center xl:justify-end"
      data-cy="UpperLinks_ul"
    >
      {links
        .filter(({ name }) => !!name)
        .map(({ name, link, icon }, index) => (
          <li key={`${name}${index}`}>
            <a
              tw="ml-8 text-black"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                pushClickMenuGTMEvent({
                  text: name,
                });
              }}
            >
              {!!icon && (
                <img
                  tw="w-[30px] h-[30px] mr-3.5 inline-block"
                  src={icon}
                  alt=""
                />
              )}
              {!!name && <span tw="block xl:inline">{name}</span>}
            </a>
          </li>
        ))}
    </ul>
  );
};

export default UpperLinks;
